import * as yup from 'yup'
import { CampoDinamico } from '@modules/convite/interfaces/CampoDinamico'
import { cpf } from 'cpf-cnpj-validator'

function findField(fields: CampoDinamico[], key: string){
    return fields.find(({ controllerName }) => controllerName === key)!
}

export function createDynamicFieldsFormValues<T>(fields: CampoDinamico[], initialValues?: T){

    const keys = fields.map(item => item.controllerName)

    if(!initialValues) return Object.fromEntries(keys.map(item => [item, ''] ))

    const formValues = Object.fromEntries(keys.map(item => 
        [item, (initialValues as any)[item] ?? '']    
    ))
    
    for (const formValue in formValues){
        const campo = fields.find(x=> x.controllerName === formValue)
        if(campo){
            if(campo.tipo ==='datetime' && (formValues as any)[formValue]){
                const strDate :string[] = (formValues as any)[formValue].toString().split('T')
                if(strDate[0]) (formValues as any)[formValue] = strDate[0]
            }
        }
    }
  

    return {...formValues, marca:(initialValues as any)['marca'], modelo:(initialValues as any)['modelo'], placa:(initialValues as any)['placa']}
}

export function createDynamicFieldsFormSchema(fields: CampoDinamico[]){

    const keys = [...fields.map(item => item.controllerName)]
    const formShapeObrigatorio = Object.fromEntries(keys.filter(f => findField(fields, f).flagObrigatorio === true).map(item => 
        [item, yup[findField(fields, item).tipo === 'datetime' ? 'date' : 'string']().required(`Preencha ${findField(fields, item).label}`)]
        
    ))

    const formShapeMin = Object.fromEntries(keys.filter(f => findField(fields, f).tipo === 'text').map(item => 
        [item, yup['string']()
        .min(4 ,`${findField(fields, item).label} muito curto`)]
        
    ))
    
    const formShapeCPF = Object.fromEntries(keys.filter(f => findField(fields, f).controllerName === 'cpf').map(item => 
        [item, yup['string']()
        .test('cpf','CPF inválido',(value) => (value==='' || value===undefined ?true: cpf.isValid(value as string, true)))]
        
    ))

    //const keysVeiculo = ['marca', 'modelo', 'placa']

    // const formShapeVeiculo = Object.fromEntries(keysVeiculo.map(item => 
    //     [item, yup['string']()
    //     .min(3 ,`${item} muito curto`)]
        
    // ))


    return yup.object().shape({...formShapeObrigatorio, ...formShapeMin, ...formShapeCPF})
}